import React, { createContext, useState } from "react"

export const LanguageContext = createContext();

const LanguageProvider = (props) => {
  const [languageToUse, switchLanguage] = useState('spanish');

  return (
    <LanguageContext.Provider value={{languageToUse, switchLanguage}}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider
